export default "__VITE_ASSET__DGFVw6Zj__"